var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"student-item"},[_c('avatar',{attrs:{"width":88,"height":88,"src":_vm.item.avatar}}),_c('div',[_c('div',{staticClass:"company"},[_vm._v(" "+_vm._s(_vm.item.company)+" ")]),_c('div',[_vm._v(_vm._s(_vm.item.jobs)+" "+_vm._s(_vm.item.name))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }